import { baseUrl } from "../../../config";
//import VuePdfEmbed from "vue-pdf-embed";

export default {
  components: {
    //VuePdfEmbed,
  },
  props: { file: Object },

  data() {
    return {
      loading: false,
    };
  },
  created() {
    if (this.$store.state.isMobile) {
      this.loading = true;
    }
  },

  methods: {
    createDownloadLink() {
      let downloadLink = `${baseUrl}/download?file=${this.file.id}`;

      downloadLink += `&company=${this.$store.state.company}`;
      downloadLink += `&myspace=${this.file.myspace}`;

      if (this.$store.state.user) {
        downloadLink += `&key=${this.$store.state.user.key}`;
      }

      return downloadLink;
    },
    handleDoneLoading() {
      this.loading = false;
    },
  },
};
